import './index.scss'
import React from 'react'
import Editable from "../../../components/editable/index";

// 我们的团队
const Carousel = (props) => {
  //
  return [{
    uid: 'carousel-1',
    html:(
      <div className="section-carousel">
        <div id={"carousel-" + props.id} className="carousel slide" data-ride="carousel">
          <ol className="carousel-indicators">
            {props.list.items.map((item, index) =>
              <li data-target={"#carousel-" + props.id}
                  key={"indicator-"+index}
                  data-slide-to={index}
                  className={index === 0 ? "active" : null}>
              </li>
            )}
          </ol>
          
          <div className="carousel-inner" role="listbox">
            {props.list.items.map((item, index) =>
              <div className={`item hero ${index === 0 ? 'active' : ''}`}
                   key={"carousel-inner-" + index}
                   style={{backgroundImage: `url(${item.media.src})`}}>
                <Editable {...item.media} />
                <div className="va-container">
                  <div className="va-middle">
                    { !item.description.is_hidden && <h2>{item.title.content}</h2> }
                    { !item.description.is_hidden && <div>{item.description.content}</div> }

                    {
                      !item.button.is_hidden &&
                      <div className="actions-wrap">
                        <a href={item.button.link} className="btn btn-lg btn-outline-inverse">
                          { item.button.title }
                        </a>
                      </div>
                    }
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }, {
    uid: 'carousel-2',
    html:(
      <div className="section-carousel section-carousel-products">
        <div id={"carousel-" + props.id} className="carousel slide" data-ride="carousel">
          <ol className="carousel-indicators">
            {props.list.items.map((item, index) =>
              <li data-target={"#carousel-" + props.id}
                  key={"indicator-"+index}
                  data-slide-to={index}
                  className={index === 0 ? "active" : null}>
              </li>
            )}
          </ol>

          <div className="carousel-inner" role="listbox">
            {props.list.items.map((item, index) =>
              <a href={item.button.href || ""}
                 className={`item ${index === 0 ? 'active' : ''}`}
                 style={{backgroundImage: `url(${item.media.src + "?imageMogr2/thumbnail/2500x>"})`}}
                 key={"carousel-inner-" + index}>
              </a>
            )}
          </div>
          
          <a className="left carousel-control" href={"#carousel-" + props.id} role="button" data-slide="prev">
            <span className="fi fi-angle-left" aria-hidden="true"> </span>
            <span className="sr-only">Previous</span>
          </a>
          <a className="right carousel-control" href={"#carousel-" + props.id} role="button" data-slide="next">
            <span className="fi fi-angle-right" aria-hidden="true"> </span>
            <span className="sr-only">Next</span>
          </a>
        </div>
      </div>
    )
  }]
}

export default Carousel


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/carousel/index.js